import React, { useState } from "react";
import "../styles.scss";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import { ActionButton } from "../../../components";
import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2";

const LocationLists = ({
  t,
  zoneName,
  accdata,
  checkedValues,
  setCheckedValues,
  setzipCodesRows,
  setRows,
  rows,
  zipCodesRows,
  checkboxAllValue,
  setCheckboxValue,
  addedCps,
  setAddedCps,
  setSelectedProvince,
}) => {
  const [zoneList, setZoneList] = useState([]);

  // Filtrado de CPs ya seleccionados
  const CpsandLocality = accdata.map((obj) => ({
    cp: obj.zip_code,
    locality: obj.locality_name,
  }));

  const cpsandlocality = CpsandLocality.filter((item) =>
    checkedValues.includes(`${item.cp} - ${item.locality}`)
  );

  const handleAddCp = () => {
    // Evitar duplicados
    const catchErrorCp = addedCps.filter((item) =>
      checkedValues.includes(`${item.cp} - ${item.locality}`)
    );

    if (catchErrorCp.length > 0) {
      Swal.fire({
        title: catchErrorCp
          .map((item) => `CP: ${item.cp} ya pertenece a una zona.`)
          .join("\n"),
        confirmButtonText: "Cerrar",
      });
      return;
    }

    const filtered = cpsandlocality.filter(
      (item) =>
        !addedCps.some((i) => i.locality === item.locality)
    );

    setZoneList((prev) =>
      prev.concat(
        filtered.map((item) => (
          <ListGroupItem
            key={uuidv4()}
            className="location-list-item"
            style={{ textAlign: "center" }}
          >
            {item.cp} - {item.locality}
          </ListGroupItem>
        ))
      )
    );

    setAddedCps((prev) => prev.concat(filtered));
    setCheckedValues([]);
    setSelectedProvince?.();
    if (checkboxAllValue) setCheckboxValue(false);
  };

  const handleDelete = () => {
    setZoneList((prev) =>
      prev.filter(
        (item) =>
          !checkedValues.includes(
            `${item.props.children.split(" - ")[0]} - ${
              item.props.children.split(" - ")[1]
            }`
          )
      )
    );

    setAddedCps((prev) =>
      prev.filter(
        (item) =>
          !checkedValues.includes(`${item.cp} - ${item.locality}`)
      )
    );

    setCheckedValues([]);
    if (checkboxAllValue) setCheckboxValue(false);
    setSelectedProvince?.();
  };

  return (
    <div>
      <h5 style={{ textAlign: "center", padding: "0.5rem" }}>
        {zoneName || "Zona"}
      </h5>
      <ListGroup className="location-list">{zoneList}</ListGroup>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyItems: "center",
          padding: "1rem",
        }}
      >
        <ActionButton onClick={handleAddCp}>
          {t("locationByZone.actionButton3")}
        </ActionButton>
        <ActionButton onClick={handleDelete}>
          {t("locationByZone.actionButton4")}
        </ActionButton>
      </div>
    </div>
  );
};

export default LocationLists;
